var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #00095b;\n      }\n\n      .cls-1 {\n        clip-rule: evenodd;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-1",
    d: "M1483.461,815.755a1.338,1.338,0,0,1,1.331,1.255l0,.078h1.333a1.334,1.334,0,0,1,.078,2.665l-.078,0h-5.333a1.333,1.333,0,0,1-.078-2.665l.078,0h1.333A1.337,1.337,0,0,1,1483.461,815.755Zm3.067,8,.933.933-5.333,5.333-2.667-2.667.933-.933,1.733,1.733Zm-8.067-6.667a3.1,3.1,0,0,0-.329,1.194l0,.14h-1.333v16h13.333v-16h-1.333l0-.14a3.053,3.053,0,0,0-.271-1.071l-.058-.122h1.667a1.338,1.338,0,0,1,1.331,1.255l0,.078v16a1.338,1.338,0,0,1-1.255,1.331l-.078,0h-13.333a1.337,1.337,0,0,1-1.331-1.255l0-.078v-16a1.338,1.338,0,0,1,1.255-1.331l.078,0Z",
    transform: "translate(-1475.461 -815.755)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    className: "cls-2",
    width: 135.653,
    height: 96.957
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(-1475.461 -815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    className: "cls-3",
    transform: "translate(1475.461 815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(-79.131 -38.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    className: "cls-2",
    width: 16.87,
    height: 20.87,
    transform: "translate(78.696 37.826)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatos);
export default __webpack_public_path__ + "static/media/datos.0e7e490194abc069a19c10857c662e7a.svg";
export { ForwardRef as ReactComponent };